import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Box, Typography } from '@mui/material';

import QrCodeFragment from './QrCodeFragment';
import ScanCode from './ScanCodeFragment';

interface Props {
  isUnableToScan?: boolean;
  onUnableToScan: { (): void };
  otpSecretKey: string;
  otpAccountName: string;
}

const UserOtpQrCodeFragment = (props: Props): React.JSX.Element => {
  const { isUnableToScan, onUnableToScan, otpSecretKey, otpAccountName: otpAccountNameRaw } = props;

  if (!otpSecretKey) {
    return null;
  }

  // This will show up as Plooto (<otpAccountName>) in authenticator with the associated user email
  const otpAccountName = encodeURIComponent(otpAccountNameRaw);
  const qrCodeData = `otpauth://totp/Plooto:${otpAccountName}?secret=${otpSecretKey}&issuer=Plooto`;

  return (
    <>
      <Box mt={2} mb={1}>
        <Typography>
          <FormattedMessage defaultMessage="Follow the steps below to complete the two-step authentication setup" />
        </Typography>

        <Box mt={3}>
          <ol>
            <li>
              <FormattedMessage defaultMessage="Get an Authenticator App from the App Store or Google Play Store." />
            </li>
            <li>
              <FormattedMessage defaultMessage="In the app, select set up account." />
            </li>
            <li>
              <FormattedMessage defaultMessage="Choose scan barcode." />
            </li>
          </ol>
        </Box>
      </Box>
      <Box
        flexDirection="column"
        mb={2}
        display="flex"
        alignContent="center"
        alignItems="center"
        justifyContent="center"
        justifyItems="center"
      >
        <QrCodeFragment data={qrCodeData} />

        <Box>
          <ScanCode
            isUnableToScan={isUnableToScan}
            onUnableToScan={onUnableToScan}
            otpSecretKey={otpSecretKey}
          />
        </Box>
      </Box>
      <Box mt={1} mb={3}>
        <Typography gutterBottom>
          <FormattedMessage defaultMessage="After you have scanned the QR code above press the continue button to activate your two-step Authentication by confirming authenticator code." />
        </Typography>
      </Box>
    </>
  );
};

export default memo(UserOtpQrCodeFragment);
